export interface MarginsDifferences {
    propertyName: string;
    valueInPreviousMargin: any;
    valueInCurrentMargin: any;
}

export enum PropertyNames {
    ACTUALMARGIN = 'Actual Margin',
    EXTENSION = 'Extension',
    SPECIALTY = 'Specialty',
    STARTDATETEXT = 'Start',
    ENDDATETEXT = 'End',
    DAYSLENGTH = 'Days Length',
    SHIFTTEXT = 'Shifts',
    SHIFTTYPE = 'Shift Type',
    BASEPAYRATE = 'Base Pay Rate',
    BASEBILLRATE = 'Base Bill Rate',
    OTPAYRATE = 'OT Pay Rate',
    OTBILLRATE = 'OT Bill Rate',
    WEEKLYSTIPEND = 'Weekly Stipend',
    ORIENTATIONTEXT = 'Orientation',
    RTOTEXT = 'RTO Dates',
    ISRTOAPPROVED = 'RTO Approval',
    CONTRACTFEES = 'Contract Fees',
    ISBILLOVERTIME = 'Bill OverTime',
    DISCOUNTPERCENT = 'Early Payment Discount',
    OTBILLRULESTEXT = 'OT Bill Rules'
}
